const getImpressionStatus = isPremium => {
  if (isPremium) {
    return 'Upgraded'
  }
  return 'Basic'
}

export { getImpressionStatus }
